import { ProductCard } from './product-card';
import withPointerUpHandling from 'common/hocs/with-pointer-up-handling';

export const ProductCardWithClickEvent = withPointerUpHandling(ProductCard);
